import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async ({ ...params }) => {
  return await dponetAPI.get('backoffice/payment_services', { params })
}

const getEligibleGovernanceProjectTemplates = async () => {
  return await dponetAPI.get(
    'backoffice/payment_services/eligible_governance_project_templates',
  )
}

const show = async ({ paymentServiceTemplateId = '' }) => {
  return await dponetAPI.get(
    `backoffice/payment_services/${paymentServiceTemplateId}`,
  )
}

const create = async ({ ...data }) => {
  return await dponetAPI.post('backoffice/payment_services', data)
}

const update = async ({ paymentServiceTemplateId, ...data }) => {
  return await dponetAPI.put(
    `backoffice/payment_services/${paymentServiceTemplateId}`,
    data,
  )
}

const destroy = async ({ paymentServiceTemplateId }) => {
  return await dponetAPI.delete(
    `backoffice/payment_services/${paymentServiceTemplateId}`,
  )
}

const createBillingEmail = async ({ paymentServiceTemplateId, email }) => {
  return await dponetAPI.post(
    `backoffice/payment_services/${paymentServiceTemplateId}/billing_emails`,
    { billingEmail: { email } },
  )
}

const destroyBillingEmail = async ({
  paymentServiceTemplateId,
  billingEmailId,
}) => {
  return await dponetAPI.delete(
    `backoffice/payment_services/${paymentServiceTemplateId}/billing_emails/${billingEmailId}`,
  )
}

const paymentServiceTemplates = {
  get,
  getEligibleGovernanceProjectTemplates,
  show,
  create,
  update,
  destroy,
  createBillingEmail,
  destroyBillingEmail,
}

export default paymentServiceTemplates
